import { useRef, useState } from 'react'

import { Button } from '#base/js/common/components/button'
import { Modal } from '#base/js/common/components/modal'
import { Select } from '#base/js/common/components/select'
import { Switch } from '#base/js/common/components/switch'
import { NotificationManager } from '#base/js/common/components/Notifications'
import { TextInput } from '#base/js/common/components/text-input'
import { DisplayFilter } from '#base/js/reports/blocks/filter'
import { exportService } from '#base/js/common/services/export.service'

import { LABEL } from './control-bar/constants'
import { useStyles } from './chart-exporter.style'

export const SUPPORTED_FILE_TYPES = [
  { value: '.jpeg', label: '.jpeg', type: 'jpeg' },
  { value: '.png', label: '.png', type: 'png' },
  { value: '.svg', label: '.svg', type: 'svg' }
]

export const ChartExporter = ({
  selections,
  defaults = {
    filename: 'chart',
    filetype: 'png'
  },
  isOpen = false,
  onClose = () => {},
  children
}) => {
  const classes = useStyles()

  const [filename, setFilename] = useState(getDefaultFilename())
  const [filetype, setFiletype] = useState(getDefaultFiletype())
  const [includeFilters, setIncludeFilters] = useState(true)

  const contentRef = useRef()

  function getDefaultFilename () {
    return defaults.filename || ''
  }

  function getDefaultFiletype () {
    return (defaults.filetype && SUPPORTED_FILE_TYPES.find(({ type }) => type === defaults.filetype)) || SUPPORTED_FILE_TYPES[0]
  }

  function download (url) {
    const link = document.createElement('a')
    link.download = `${filename}${filetype.value}`
    link.href = url
    link.click()
  }

  async function onExport () {
    try {
      const dataUrl = await exportService.toImage(contentRef.current, filetype.type)
      download(dataUrl)
    } catch (err) {
      NotificationManager.create({
        type: 'error',
        timeOut: 5000,
        message: err.message
      })
    }
  }

  return <Modal
    isOpen={isOpen}
    onClose={onClose}
    title="Export Chart"
  >
    <div className={classes.configRow}>
      <TextInput
        labelClass={classes.filename}
        label={'Filename'}
        value={filename}
        onChange={(e) => setFilename(e.target.value)}
      />
      <Select
        labelClass={classes.filetype}
        label={'type'}
        options={SUPPORTED_FILE_TYPES}
        value={SUPPORTED_FILE_TYPES.find(({ value }) => value === filetype.value)}
        onChange={(value) => setFiletype(value)}
      />
    </div>
    <div className={classes.configRowRight}>
      <Switch
        onLabel="Include filters"
        offLabel="Include filters"
        isOn={includeFilters}
        onToggle={() => setIncludeFilters(!includeFilters)}
      />
    </div>
    <div className={classes.contentContainer}>
      <div ref={contentRef} className={classes.content}>
        {includeFilters && (
          <div className={classes.filterContainer}>
            {selections?.strata && (
              <DisplayFilter label={LABEL.STRATA}>
                {selections.strata.label}
              </DisplayFilter>
            )}
            {selections?.slider && (
              <DisplayFilter label={selections.slider.key}>
                {selections.slider.label}
              </DisplayFilter>
            )}
            {selections?.filters && Object.entries(selections.filters).map(([key, { label }]) => (
              <DisplayFilter key={key} label={key}>
                {label}
              </DisplayFilter>
            ))}
            {selections?.thresholdFilters && Object.entries(selections.thresholdFilters).map(([key, { label }]) => (
              <DisplayFilter key={key} label={key}>
                {label}
              </DisplayFilter>
            ))}
          </div>
        )}
        <div className={classes.chartContainer}>
          {children}
        </div>
      </div>
    </div>
    <div className={classes.actions}>
      <Button
        disabled={!filename}
        onClick={onExport}
      >
        Download
      </Button>
    </div>
  </Modal>
}
